import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  pl: {
    translation: {
      login: {
        title: 'Logowanie',
        errorInvalidCredentials: 'Wprowadzono błędny login lub hasło.',
        errorInvalidCredentialsTitle: 'Błędne dane',
        loginLabel: 'Login',
        passwordLabel: 'Hasło',
        submit: 'Zaloguj',
      },
      nav: {
        buildings: 'Obiekty',
        videos: 'Filmy',
        controlPanel: 'Panel kontrolny',
        files: 'Pliki',
        users: 'Użytkownicy',
        logout: 'Wyloguj',
        langPl: 'PL',
        langEn: 'EN',
      },
      buildings: {
        newBuilding: 'Nowy obiekt',
        nameLabel: 'Nazwa budynku',
        namePlaceholder: 'Nazwa budynku',
        nameHelp:
          'Nazwa budynku - formalna nazwa, niewidoczna dla użytkowników aplikacji mobilnych',
        codeLabel: 'Kod obiektu',
        codePlaceholder: 'kod',
        codeHelp:
          'Krótki, unikalny i jednoznaczny kod obiektu widoczny w aplikacji mobilnej',
        addressLabel: 'Adres obiektu',
        addressPlaceholder: 'adres',
        addressHelp: 'Adres obiektu',
        usersCountLabel: 'Liczba użytkowników obiektu',
        usersCountPlaceholder: '0',
        usersCountHelp:
          'Opcjonalnie - możesz podać początkową liczbę użytkowników, których utworzyć wraz z dodaniem obiektu do bazy danych',
        save: 'Zapisz',
        add: 'Dodaj',
        tableHeaderLp: '#',
        tableHeaderName: 'Nazwa',
        tableHeaderCode: 'Kod',
        tableHeaderAddress: 'Adres',
        tableHeaderUsers: 'Użytkownicy',
        tableHeaderEdit: 'Edycja',
      },
      buildingData: {
        cardTitle: 'Dane obiektu',
        nameLabel: 'Nazwa obiektu',
        namePlaceholder: 'nazwa obiektu',
        addressLabel: 'Adres obiektu',
        addressPlaceholder: 'adres',
        codeLabel: 'Kod obiektu',
        codePlaceholder: 'kod',
        save: 'Zapisz',
        edit: 'Edycja',
      },
      buildingUsers: {
        cardTitle: 'Użytkownicy i zarząd',
        mobileUsersLabel: 'Użytkownicy mobilni',
        mobileUsersAdd: 'Dodaj',
        mobileUsersHelp:
          'Użytkownicy mobilni przypisani do tego obiektu. Aby wygenerować nowe hasła, kliknij dodaj i wprowadź liczbę użytkowników. System poprosi o zapis pliku, w którym będą znajdowały się wygenerowane hasła.',
        staffLabel: 'Obsługa obiektu',
        staffAddManager: 'Dodaj zarządcę',
        staffHelp:
          'Obsługa obiektu to zarządcy oraz pracownicy ochrony mający dostęp do systemu z poziomu strony www.\nAby wygenerować nowe konto pracownika, kliknij dodaj i wprowadź dane. System poprosi o zapis pliku, w którym będą znajdowały się dane pracownika.',
        tableHeaderLp: '#',
        tableHeaderLogin: 'Login',
        tableHeaderEmail: 'Email',
        tableHeaderRole: 'Rola',
        tableHeaderActions: 'Akcje',
        edit: 'Edycja',
        delete: 'Usuń',
        confirmDeleteUser: 'Potwierdź usunięcie użytkownika: {{login}}',
        addUsersPrompt: 'Wprowadź liczbę użytkowników do dodania',
        addUsersInvalid: 'Wprowadzono nieprawidłową liczbę użytkowników.',
        addUsersButton: 'Dodaj',
        addUsersHelp:
          'Użytkownicy mobilni przypisani do tego obiektu. Aby wygenerować nowe hasła, kliknij dodaj i wprowadź liczbę użytkowników. System poprosi o zapis pliku, w którym będą znajdowały się wygenerowane hasła.',
        managerModalTitleEdit: 'Edycja pracownika',
        managerModalTitleNew: 'Nowy pracownik',
        managerLoginLabel: 'Login pracownika',
        managerLoginHelp: 'Login zarządcy/obsługi obiektu',
        managerPasswordLabel: 'Hasło pracownika',
        managerPasswordPlaceholderEdit:
          'wprowadź hasło aby je zmienić',
        managerPasswordPlaceholderNew: 'hasło',
        managerPasswordHelp:
          'Hasło zarządcy/obsługi obiektu (pozostaw puste - system automatycznie wygeneruje hasło)',
        managerRoleLabel: 'Rola pracownika',
        managerRoleManager: 'Zarządca',
        managerRoleSteward: 'Ochrona',
        managerModalSave: 'Dodaj',
      },
      files: {
        cardTitle: 'Dokumenty obiektu',
        filePlaceholder: 'Wybierz plik',
        typePlaceholder: 'Typ pliku',
        typeIbp: 'Instrukcja PPOŻ',
        typeEvac: 'Plany Ewak.',
        typeTraining: 'Szkolenie',
        addButton: 'Dodaj',
        fileHelp:
          'Wybierz plik z dysku. Maksymalny dopuszczalny rozmiar pliku: 15 MB',
        tableHeaderLp: '#',
        tableHeaderName: 'Nazwa',
        tableHeaderType: 'Typ',
        tableHeaderSize: 'Rozmiar',
        tableHeaderActions: 'Akcje',
        preview: 'Podgląd',
        delete: 'Usuń',
        confirmDeleteFile: 'Potwierdź skasowanie pliku: {{name}}',
      },
      calendar: {
        prevMonth: 'Poprzedni miesiąc',
        nextMonth: 'Następny miesiąc',
        addReview: 'Dodaj przegląd',
        add: 'Dodaj',
        weekDays: ['Pn', 'Wt', 'Śr', 'Czw', 'Pt', 'Sb', 'Nd'],
        incomingTitle: 'Zbliżające się przeglądy',
        incomingUnderstand: 'Rozumiem',
        modalTitle: 'Przegląd',
        nameLabel: 'Nazwa',
        nameHelp: 'Krótka nazwa wydarzenia',
        descriptionLabel: 'Opis',
        descriptionHelp: 'Wpisz opis przeglądu, wydarzenia',
        dateLabel: 'Data',
        repeatLabel: 'Powtarzanie',
        repeat0: 'nie powtarza się',
        repeat1: 'co miesiąc',
        repeat3: 'kwartalnie',
        repeat6: 'półrocznie',
        repeat12: 'co roku',
        repeat24: 'co dwa lata',
        repeat36: 'co trzy lata',
        repeat60: 'co pięć lat',
        errorNoDate: 'Nie wprowadzono daty',
        errorNoName: 'Nie wprowadzono nazwy wydarzenia',
        cancel: 'Anuluj',
        save: 'Zapisz',
        delete: 'Usuń',
      },
      control: {
        tabCalendar: 'Kalendarz',
        tabEvacPlans: 'Plany ewakuacyjne',
      },
      notifications: {
        sendButton: 'Wyślij powiadomienie',
        sendButtonShort: 'Wyślij',
        sendModalTitle: 'Wyślij powiadomienie',
        sendModalInfo:
          'Wybierz powiadomienie z listy, które zostanie wysłane do użytkowników aplikacji mobilnych w obiekcie.',
        threatsHeader: 'Zagrożenia',
        warningsHeader: 'Ostrzeżenia',
        customNotificationLabel: 'Wprowadź tekst powiadomienia',
        writeNotificationHeader: 'Napisz powiadomienie:',
        cancel: 'Anuluj',
        wait: 'Czekaj',
        confirmDeleteReview:
          'Proszę potwierdzić usunięcie przeglądu z kalendarza',
        evacuatedLabel: 'Ewakuowanych:',
      },
      messenger: {
        rescueTitle: 'RATUNEK',
        rescueBody:
          'Użytkownik aplikacji potrzebuje pomocy.\nOdbierz rozmowę aby rozpocząć czat z użytkownikiem.',
        reject: 'Odrzuć',
        accept: 'Odbierz',
        chatTitle: 'Czat',
        minimize: 'Minimalizuj',
        close: 'Zamknij',
        inputPlaceholder: 'wprowadź wiadomość',
        send: 'Wyślij',
        chatEnded: 'Rozmowa została zakończona.',
        confirmEndChat:
          'Potwierdź zakończenie czatu z użytkownikiem.',
      },
      push: {
        close: 'Zamknij',
      },
      call: {
        call: 'Zadzwoń',
        hangup: 'Rozłącz się',
        youAreMuted:
          "You're automatically muted, unmute yourself!",
      },
      videos: {
        tableHeaderLp: '#',
        tableHeaderName: 'Nazwa',
        tableHeaderCategory: 'Kategoria',
        tableHeaderActions: 'Akcje',
        delete: 'Usuń',
        confirmDeleteVideo: 'Potwierdź usunięcie filmu: {{name}}',
        add: 'Dodaj',
        uploadModalTitle: 'Prześlij plik video',
        fileLabel: 'Plik video',
        fileHelp:
          'Max. 64MB -  filmy o większym rozmiarze spowodują wystąpienie błędu, powinny zostać skompresowane przed wysłaniem na serwer.',
        nameLabel: 'Nazwa filmu',
        namePlaceholder: 'wprowadź nazwę',
        nameHelp: 'Widoczna dla użytkownika nazwa',
        categoryLabel: 'Kategoria',
        categoryKpp: 'Ratownictwo medyczne',
        categoryPpoz: 'Ochrona ppoż.',
        upload: 'Prześlij',
        uploadProgressInfo:
          'Film jest przesyłany na serwer i tam przechodzi ostateczną obróbkę. Proces ten może zająć kilka minut.',
      },
      evacuation: {
        listTitle: 'Plany ewakuacyjne',
      },
    },
  },
  en: {
    translation: {
      login: {
        title: 'Login',
        errorInvalidCredentials: 'Invalid login or password.',
        errorInvalidCredentialsTitle: 'Invalid data',
        loginLabel: 'Login',
        passwordLabel: 'Password',
        submit: 'Sign in',
      },
      nav: {
        buildings: 'Buildings',
        videos: 'Videos',
        controlPanel: 'Control panel',
        files: 'Files',
        users: 'Users',
        logout: 'Logout',
        langPl: 'PL',
        langEn: 'EN',
      },
      buildings: {
        newBuilding: 'New building',
        nameLabel: 'Building name',
        namePlaceholder: 'Building name',
        nameHelp:
          'Building name - formal name, not visible to mobile app users',
        codeLabel: 'Building code',
        codePlaceholder: 'code',
        codeHelp:
          'Short, unique and unambiguous building code visible in the mobile app',
        addressLabel: 'Building address',
        addressPlaceholder: 'address',
        addressHelp: 'Building address',
        usersCountLabel: 'Number of building users',
        usersCountPlaceholder: '0',
        usersCountHelp:
          'Optional - you can provide the initial number of users to be created together with the building in the database',
        save: 'Save',
        add: 'Add',
        tableHeaderLp: '#',
        tableHeaderName: 'Name',
        tableHeaderCode: 'Code',
        tableHeaderAddress: 'Address',
        tableHeaderUsers: 'Users',
        tableHeaderEdit: 'Edit',
      },
      buildingData: {
        cardTitle: 'Building data',
        nameLabel: 'Building name',
        namePlaceholder: 'building name',
        addressLabel: 'Building address',
        addressPlaceholder: 'address',
        codeLabel: 'Building code',
        codePlaceholder: 'code',
        save: 'Save',
        edit: 'Edit',
      },
      buildingUsers: {
        cardTitle: 'Users and staff',
        mobileUsersLabel: 'Mobile users',
        mobileUsersAdd: 'Add',
        mobileUsersHelp:
          'Mobile users assigned to this building. To generate new passwords, click add and enter the number of users. The system will ask to save a file containing generated passwords.',
        staffLabel: 'Building staff',
        staffAddManager: 'Add manager',
        staffHelp:
          'Building staff are managers and security staff with access to the system from the website.\nTo generate a new staff account, click add and enter the data. The system will ask to save a file containing staff data.',
        tableHeaderLp: '#',
        tableHeaderLogin: 'Login',
        tableHeaderEmail: 'Email',
        tableHeaderRole: 'Role',
        tableHeaderActions: 'Actions',
        edit: 'Edit',
        delete: 'Delete',
        confirmDeleteUser: 'Confirm deletion of user: {{login}}',
        addUsersPrompt: 'Enter the number of users to add',
        addUsersInvalid: 'Invalid number of users.',
        addUsersButton: 'Add',
        addUsersHelp:
          'Mobile users assigned to this building. To generate new passwords, click add and enter the number of users. The system will ask to save a file containing generated passwords.',
        managerModalTitleEdit: 'Edit staff member',
        managerModalTitleNew: 'New staff member',
        managerLoginLabel: 'Staff login',
        managerLoginHelp: 'Manager / building staff login',
        managerPasswordLabel: 'Staff password',
        managerPasswordPlaceholderEdit:
          'enter password to change it',
        managerPasswordPlaceholderNew: 'password',
        managerPasswordHelp:
          'Manager / building staff password (leave empty - the system will generate a password automatically)',
        managerRoleLabel: 'Staff role',
        managerRoleManager: 'Manager',
        managerRoleSteward: 'Security',
        managerModalSave: 'Save',
      },
      files: {
        cardTitle: 'Building documents',
        filePlaceholder: 'Choose file',
        typePlaceholder: 'File type',
        typeIbp: 'Fire safety instructions',
        typeEvac: 'Evacuation plans',
        typeTraining: 'Training',
        addButton: 'Add',
        fileHelp:
          'Choose a file from disk. Maximum allowed file size: 15 MB',
        tableHeaderLp: '#',
        tableHeaderName: 'Name',
        tableHeaderType: 'Type',
        tableHeaderSize: 'Size',
        tableHeaderActions: 'Actions',
        preview: 'Preview',
        delete: 'Delete',
        confirmDeleteFile: 'Confirm deletion of file: {{name}}',
      },
      calendar: {
        prevMonth: 'Previous month',
        nextMonth: 'Next month',
        addReview: 'Add inspection',
        add: 'Add',
        weekDays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        incomingTitle: 'Upcoming inspections',
        incomingUnderstand: 'Understood',
        modalTitle: 'Inspection',
        nameLabel: 'Name',
        nameHelp: 'Short event name',
        descriptionLabel: 'Description',
        descriptionHelp: 'Enter inspection / event description',
        dateLabel: 'Date',
        repeatLabel: 'Repeat',
        repeat0: 'does not repeat',
        repeat1: 'monthly',
        repeat3: 'quarterly',
        repeat6: 'every six months',
        repeat12: 'yearly',
        repeat24: 'every two years',
        repeat36: 'every three years',
        repeat60: 'every five years',
        errorNoDate: 'Date is required',
        errorNoName: 'Event name is required',
        cancel: 'Cancel',
        save: 'Save',
        delete: 'Delete',
      },
      control: {
        tabCalendar: 'Calendar',
        tabEvacPlans: 'Evacuation plans',
      },
      notifications: {
        sendButton: 'Send notification',
        sendButtonShort: 'Send',
        sendModalTitle: 'Send notification',
        sendModalInfo:
          'Choose a notification from the list that will be sent to mobile app users in the building.',
        threatsHeader: 'Threats',
        warningsHeader: 'Warnings',
        customNotificationLabel: 'Enter notification text',
        writeNotificationHeader: 'Write notification:',
        cancel: 'Cancel',
        wait: 'Please wait',
        confirmDeleteReview:
          'Please confirm deleting the inspection from the calendar',
        evacuatedLabel: 'Evacuated:',
      },
      messenger: {
        rescueTitle: 'HELP',
        rescueBody:
          'A mobile app user needs help.\nAnswer the call to start a chat with the user.',
        reject: 'Reject',
        accept: 'Answer',
        chatTitle: 'Chat',
        minimize: 'Minimize',
        close: 'Close',
        inputPlaceholder: 'enter message',
        send: 'Send',
        chatEnded: 'Conversation has ended.',
        confirmEndChat:
          'Confirm ending the chat with the user.',
      },
      push: {
        close: 'Close',
      },
      call: {
        call: 'Call',
        hangup: 'Hang up',
        youAreMuted: 'You\'re automatically muted, unmute yourself!',
      },
      videos: {
        tableHeaderLp: '#',
        tableHeaderName: 'Name',
        tableHeaderCategory: 'Category',
        tableHeaderActions: 'Actions',
        delete: 'Delete',
        confirmDeleteVideo: 'Confirm deletion of video: {{name}}',
        add: 'Add',
        uploadModalTitle: 'Upload video file',
        fileLabel: 'Video file',
        fileHelp:
          'Max. 64MB - larger videos will cause an error, compress them before uploading to the server.',
        nameLabel: 'Video name',
        namePlaceholder: 'enter name',
        nameHelp: 'Name visible to the user',
        categoryLabel: 'Category',
        categoryKpp: 'Medical rescue',
        categoryPpoz: 'Fire safety',
        upload: 'Upload',
        uploadProgressInfo:
          'The video is being uploaded to the server and processed there. This may take a few minutes.',
      },
      evacuation: {
        listTitle: 'Evacuation plans',
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pl',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;

